var _path, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgButtonAppStoreLogo = function SvgButtonAppStoreLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.629 20.732a5.228 5.228 0 0 1 2.489-4.385 5.35 5.35 0 0 0-4.216-2.28c-1.773-.185-3.493 1.062-4.397 1.062-.92 0-2.312-1.043-3.81-1.012a5.613 5.613 0 0 0-4.725 2.881c-2.043 3.537-.519 8.734 1.438 11.593.979 1.4 2.123 2.963 3.62 2.908 1.465-.06 2.012-.934 3.78-.934 1.752 0 2.266.934 3.793.899 1.572-.026 2.563-1.406 3.507-2.82.704-.997 1.245-2.1 1.604-3.266a5.05 5.05 0 0 1-3.083-4.646ZM23.743 12.187A5.146 5.146 0 0 0 24.921 8.5a5.236 5.236 0 0 0-3.388 1.753 4.897 4.897 0 0 0-1.208 3.55 4.33 4.33 0 0 0 3.418-1.616Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 39,
    rx: 5.5,
    stroke: "currentColor"
  })));
};

export default SvgButtonAppStoreLogo;